import { useEffect, useState } from "react";
import useStore from "@/hooks/useStore";
import NoPosts from "./utils/NoPosts/NoPosts";
import PostCardGrid from "./utils/PostCardGrid/PostCardGrid";

const CategoryPage = () => {
  const [posts, setPosts] = useState([]);
  const { getItems, requestedItems } = useStore();

  const postsRequest = {
    type: "posts",
    params: {
      _embed: 1,
      order: "desc",
      orderby: "date",
    },
    showLoading: true,
  };

  const getPosts = () => {
    async function fetchData() {
      await getItems(postsRequest);
      setPosts(requestedItems(postsRequest));
    }

    fetchData();
  };

  useEffect(() => {
    getPosts();
  }, []);

  return (
    <div className="container-revamp mt-40">
      <h1 className="h1-black text-light leading-tight font-light mb-6 text-[40px] lg:text-[70px]">
        Insights Categories
      </h1>
      <div className="posts-items">
        {posts.length ? (
          <>
            <PostCardGrid posts={posts} entryType="posts" />
          </>
        ) : (
          <NoPosts postType="posts" />
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
